// extracted by mini-css-extract-plugin
module.exports = {"container":"GosuslugyEducation_container__2HJxA","filters":"GosuslugyEducation_filters__MLAVg"};